module.exports = __webpack_public_path__ + "static/media/SCR-A-new3.e5ced65b.mp3";